import { render } from "./WorkspaceView.vue?vue&type=template&id=9b82b44e"
import script from "./WorkspaceView.vue?vue&type=script&lang=js"
export * from "./WorkspaceView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__